import { v4 as uuidv4} from "uuid";

function chillHop() {
    return [
        {
            name: "Slim Bobby",
            cover: "https://chillhop.com/wp-content/uploads/2020/10/23fdd99adc3e16abcb67b004ea3e748ebf433a49-1024x1024.jpg",
            artist: "Avinno",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10315",
            color: ["#b03e95","#b3098a"],
            id: uuidv4(),
            active: true,
        },
        {
            name: "Creswick",
            cover: "https://chillhop.com/wp-content/uploads/2020/10/23fdd99adc3e16abcb67b004ea3e748ebf433a49-1024x1024.jpg",
            artist: "Avinno",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10454",
            color: ["#8809b3", "#be52e3"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Flushing the Stairs",
            cover: "https://chillhop.com/wp-content/uploads/2020/09/6defa6c89a6902fdd84bccd720c2b8fd29c40990-1024x1024.jpg",
            artist: "Leavv",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9917",
            color: [],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Maple Leaf Pt.2",
            cover: "https://chillhop.com/wp-content/uploads/2020/09/2899f7cc22ab12e17d0119819aac3ca9dbab46e6-1024x1024.jpg",
            artist: "Philanthrope",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10243",
            color: [],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Soil",
            cover: "https://chillhop.com/wp-content/uploads/2020/09/2899f7cc22ab12e17d0119819aac3ca9dbab46e6-1024x1024.jpg",
            artist: "Philanthrope",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10254",
            color: [],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Du Bassin au Muret",
            cover: "https://chillhop.com/wp-content/uploads/2020/10/efaa848553d09b4d9fc0752844456e41b34de276-1024x1024.jpg",
            artist: "sadtoi",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=8810",
            color: ["blue", "lightblue"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "String Along",
            cover: "https://chillhop.com/wp-content/uploads/2020/10/efaa848553d09b4d9fc0752844456e41b34de276-1024x1024.jpg",
            artist: "sadtoi",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10315",
            color: ["blue", "lightblue"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Sleepover",
            cover: "https://chillhop.com/wp-content/uploads/2020/09/09fb436604242df99f84b9f359acb046e40d2e9e-1024x1024.jpg",
            artist: "Nymano, JK the Sage",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10130",
            color: ["purple", "pink"],
            id: uuidv4(),
            active: false,

        },
        {
            name: "Mirage",
            cover: "https://chillhop.com/wp-content/uploads/2020/09/09fb436604242df99f84b9f359acb046e40d2e9e-1024x1024.jpg",
            artist: "Nymano, J'san",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10136",
            color: ["purple", "pink"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Imagination",
            cover: "https://chillhop.com/wp-content/uploads/2020/07/24bd0da848d9718fd19af104ff5c0b11f914cb25-1024x1024.jpg",
            artist: "Montell Fish",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9332",
            color: ["lightblue", "coral"],
            id: uuidv4(),
            active: false,
        },
    ]
}





export default chillHop;